import { useState, type FormEvent } from 'react';
import { toast } from 'sonner';
import { toPayload } from '../components/RefereeForm.utils';
import { useRefereeAnswers } from './useRefereeAnswers';
import { useUpdateRefereeInfo } from './useUpdateRefereeInfo';
import type {
  RefereeConfirmFormProps,
  RefereeConfirmFormState,
  RefereeRelationship,
} from '../types/referee-app.types';

export function useRefereeConfirmForm(props: RefereeConfirmFormProps): RefereeConfirmFormState {
  const { shareId, questions, initialRelationship, initialPhone, initialJobTitle } = props;
  const [relationship, setRelationship] = useState<RefereeRelationship | null>(
    initialRelationship ?? null
  );
  const [phone, setPhone] = useState(initialPhone ?? '');
  const [jobTitle, setJobTitle] = useState(initialJobTitle ?? '');
  const answers = useRefereeAnswers(props.initialAnswers ?? []);
  const { mutate, isPending } = useUpdateRefereeInfo(shareId);

  const handleSubmit = (e: FormEvent): void => {
    e.preventDefault();
    if (!answers.validateAll(questions)) return;
    mutate(
      {
        confirmed: true,
        refereeRelationship: relationship ?? undefined,
        refereePhone: phone || undefined,
        refereeJobTitle: jobTitle || undefined,
        answers: toPayload(answers.answers),
      },
      {
        onSuccess: () => toast.success('Verification submitted successfully'),
        onError: () => toast.error('Failed to submit verification'),
      }
    );
  };

  return {
    relationship,
    setRelationship,
    phone,
    setPhone,
    jobTitle,
    setJobTitle,
    answers: answers.answers,
    answerErrors: answers.errors,
    onAnswerChange: answers.handleAnswerChange,
    handleSubmit,
    isPending,
  };
}
